const initState = {
    gates: [],
    gate: {},
    times: [],
    users: [],
    privates: { queued_actions: [] }
};

const gateReducer = (state = initState, action) => {
    switch(action.type){
        case 'GET_GATES':
            return {
                ...state,
                gates: action.gates,
                gate: {}
            }
        case 'CLEAR_GATES':
            return {
                gates: {},
                times: [],
                users: [],
                privates: { queued_actions: [] },
                gate: {}
            }
        case 'GET_GATE_DETAILS':
            return {
                ...state,
                gate: action.gate
            }
        case 'UPDATE_GATE_PRIVATES':
            return {
                ...state,
                privates: action.privates 
            };
        case 'UPDATE_TIMES':
            let times = state.times;
            times[action.i] = action.time;
            return {
                ...state,
                times: times
            };
        case 'GET_GATE_USERS':
            return {
                ...state,
                users: action.users
            }
        case 'GET_GATE_TIMES':
            return {
                ...state,
                times: action.times
            }
        case 'GET_GATE_UPDATE':
            return {
                ...state,
                gate: action.gate
            };
        case 'DELETE_MISSION':
            return {
                ...state,
                gates: action.gate,
                gate: {}
            }
        default:
            return state;
    }
};

export default gateReducer;